export default "__VITE_ASSET__CtZeHFcV__"